import Cookies from 'js-cookie';
const LOCAL_STORAGE_KEY = "designatedexhibitorleadcapture"

const setExhibitorLeadCapture = (leadCapturInfo) => {
    /* should look like this:
    { 
        clientId: '95e829d9-1dc3-4b23-a08d-2a25786c48b5', 
        clientName: 'NAWLA', 
        leadcaptureid: Guid,
        overwriteName: LC Name,
        expiration: 1718399263431
        exhibitorid: Guid
    }
    */
    // set expiration date
    let dateExpires = new Date();
    dateExpires.setTime(dateExpires.getTime() + (1000 * 60 * 60 * 24 * 4)); // expires in 4 days
    //leadCapturInfo.expires = dateExpires.toUTCString()
    //localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(leadCapturInfo))
    Cookies.set(LOCAL_STORAGE_KEY, JSON.stringify(leadCapturInfo), { path: '/', expires: dateExpires });
}

const getExhibitorLeadCapture = () => {
    let leadCapturInfo = Cookies.get(LOCAL_STORAGE_KEY);
    //let leadCapturInfo = localStorage.getItem(LOCAL_STORAGE_KEY)
    //if (leadCapturInfo) {
    //    const payload = JSON.parse(leadCapturInfo)
    //    //payload.exp < Date.now() / 1000
    //    if (payload.expiration < Date.now() / 1000) {
    //        localStorage.removeItem(LOCAL_STORAGE_KEY)
    //        leadCapturInfo = null
    //    }
    //} else {
    //    localStorage.removeItem(LOCAL_STORAGE_KEY)
    //}
    return leadCapturInfo && leadCapturInfo !== undefined ? JSON.parse(leadCapturInfo) : null
}

const getClientIdFromSaved = () => {
    const exhibitorLeadCapture = getExhibitorLeadCapture()
    return exhibitorLeadCapture
        ? exhibitorLeadCapture.clientId
        : null
}

const getExhibitorIdFromSaved = () => {
    const exhibitorLeadCapture = getExhibitorLeadCapture()
    return exhibitorLeadCapture
        ? exhibitorLeadCapture.exhibitorId
        : null
}

const getClientNameFromSaved = () => {
    const exhibitorLeadCapture = getExhibitorLeadCapture()
    return exhibitorLeadCapture
        ? exhibitorLeadCapture.clientName
        : null
}

const getLeadCaptureIdFromSaved = () => {
    const exhibitorLeadCapture = getExhibitorLeadCapture()
    return exhibitorLeadCapture
        ? exhibitorLeadCapture.leadCaptureId
        : null
}

const getLeadCaptureNameFromSaved = () => {
    const exhibitorLeadCapture = getExhibitorLeadCapture()
    return exhibitorLeadCapture
        ? exhibitorLeadCapture.overwriteName
        : null
}

const removeExhibitorLeadCapture = () => {
    let leadCapturInfo = Cookies.get(LOCAL_STORAGE_KEY);
    if (leadCapturInfo && leadCapturInfo !== undefined) {
        //localStorage.removeItem(LOCAL_STORAGE_KEY)
        Cookies.remove(LOCAL_STORAGE_KEY);
    }
}


export {
    setExhibitorLeadCapture,
    getExhibitorLeadCapture,
    getExhibitorIdFromSaved,
    getClientNameFromSaved,
    getClientIdFromSaved,
    getLeadCaptureIdFromSaved,
    getLeadCaptureNameFromSaved,
    removeExhibitorLeadCapture
}